import cx from 'classnames'
import styles from './SwitchCheckbox.module.css'
import { clickOnActivationKey } from '@/utils/keyboard-util'

export interface SwitchCheckboxProps {
  className?: string
  danger?: boolean
  success?: boolean
  trueLabel?: string
  falseLabel?: string
  value?: boolean
  isDisabled?: boolean
  saving?: boolean
  noText?: boolean
  onChange(e: unknown): void
  'aria-label'?: string
  testId?: string
}

/**
 * An on/off switch.
 */
export function SwitchCheckbox({
  className,
  danger,
  success,
  onChange,
  trueLabel = 'On',
  falseLabel = 'Off',
  noText = false,
  value = false,
  saving = false,
  isDisabled = false,
  'aria-label': ariaLabel,
  testId,
}: SwitchCheckboxProps) {
  value = !!value
  return (
    <div
      role="checkbox"
      className={cx(
        styles.root,
        className,
        danger && styles.danger,
        success && styles.success,
        value && styles.checked,
        saving && !isDisabled && styles.saving,
        isDisabled && styles.disabled,
      )}
      aria-checked={value ? 'true' : 'false'}
      aria-label={ariaLabel}
      aria-disabled={isDisabled || saving ? 'true' : 'false'}
      tabIndex={isDisabled ? -1 : 0}
      onClick={() => !isDisabled && !saving && onChange(!value)}
      onKeyDown={clickOnActivationKey}
      data-test={testId}
    >
      {noText ? (
        <div className={styles.noText}></div>
      ) : (
        <div className={styles.text}>{value ? trueLabel : falseLabel}</div>
      )}

      <div className={styles.toggler} />
    </div>
  )
}
